import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import { CardActions, CardContent } from '@material-ui/core';

import { invitesRef } from '../firebase';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Redirect } from 'react-router-dom';

const styles = theme => ({
    root: {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
    },
    card: {
        width: '30rem',
        height: '20%',
        top: '25%',
        margin: '0 auto',
        position: 'relative',
        textAlign: 'center',
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#fff"
    },
    cardActions: {
        height: "auto",
        display: "inline"
    }
});

class RsvpStatus extends Component {
    constructor(props) {
        super(props);

        const { id } = props.match.params;

        this.state = {
            id,            
            redirect: false
        };

    }

    submitRsvp = (rsvpStatus) => {
        invitesRef.doc(this.state.id).set({ rsvpStatus }, { merge: true })
        .then(() => {
            toast.success('RSVP status updated!!!', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });   
            this.setState({
                redirect: true,
            })
        })
        .catch(() => {
            toast.error('Somer error occurred!!!', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });  
        });
    };

    render() {
        const { classes } = this.props;

        if(this.state.redirect) {
            return(
                <Redirect to='/invites' />
            )
        }

        return (
            <div className={classes.root}>
                <Card className={classes.card}>
                    <CardContent>
                        YOUR RSVP STATUS
                    </CardContent>
                    <CardActions className={classes.textAlign + " " + classes.cardActions}>
                        <Button onClick={() => this.submitRsvp(0)} variant="raised" color="primary">YES</Button>
                        <Button onClick={() => this.submitRsvp(2)} variant="raised" color="primary">MAY BE</Button>
                        <Button onClick={() => this.submitRsvp(1)} variant="raised" color="primary">NO</Button>
                    </CardActions>
                </Card>
            </div>
        );
    }
}

RsvpStatus.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RsvpStatus);



// WEBPACK FOOTER //
// ./src/components/RsvpStatus.js